import { render } from "./Sidebar_workflow.vue?vue&type=template&id=0ff9bb06&scoped=true"
import script from "./Sidebar_workflow.vue?vue&type=script&lang=js"
export * from "./Sidebar_workflow.vue?vue&type=script&lang=js"

import "./Sidebar_workflow.vue?vue&type=style&index=0&id=0ff9bb06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff9bb06"]])

export default __exports__